import type { ReceiptTemplate } from '../schema';

export const vanCleefArpelsTemplate: ReceiptTemplate = {
  id: 'van-cleef-arpels',
  name: 'Van Cleef & Arpels Receipt',
  brand: 'VAN CLEEF & ARPELS',
  description: 'Van Cleef & Arpels luxury jewelry receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'vca-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/van-cleef-arpels.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 14,
        addressLines: [
          '744 FIFTH AVENUE',
          'NEW YORK, NY 10019',
          '(212) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vca-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Invoice:', value: 'VCA-847291' },
          { id: 'advisor', label: 'Advisor:', value: 'M. WAZOWSKI' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '15:30' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vca-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'ALHAMBRA PENDANT YG', quantity: '1', price: '3250.00', sku: 'VCARP847291' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vca-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '3250.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (8.875%)', value: '288.44', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '3538.44', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'vca-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'AMEX ****7829',
        fields: [
          { id: 'auth', label: 'Auth:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'vca-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'CERTIFICATE OF AUTHENTICITY\nINCLUDED\n\nTHANK YOU FOR YOUR VISIT',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

